import { englishKnownLanguage } from './voiceAudition'
import type { ClipSeat } from '../../../core/src/audio/clipMenu'

/** Build-time rollout switch. Absent or any other value keeps legacy audio. */
export const clipCascadeEnabled = import.meta.env.VITE_CLIP_CASCADE === '1'
export type LanguageVoiceChoices = Partial<Record<ClipSeat, string[]>>
const keyFor = (language: string, learner?: string | null) => `ssi:clip-voices:${learner || 'guest'}:${language}`
/** Public seam for the settings piece. Choices belong to a language, not a course. */
export function languageVoiceChoices(language: string, learner?: string | null): LanguageVoiceChoices {
  try {
    const raw = localStorage.getItem(keyFor(language, learner))
    if (!raw) return learner ? languageVoiceChoices(language, null) : {}
    const value = JSON.parse(raw)
    const result: LanguageVoiceChoices = {}
    for (const seat of ['teacher', 'model1', 'model2'] as const) {
      if (Array.isArray(value?.[seat])) result[seat] = value[seat].filter((v: unknown): v is string => typeof v === 'string' && !!v)
    }
    if (!englishKnownLanguage(language)) delete result.teacher
    return result
  } catch { return {} }
}
export function setLanguageVoiceChoices(language: string, learner: string | null | undefined, choices: LanguageVoiceChoices): void {
  try { localStorage.setItem(keyFor(language, learner), JSON.stringify(choices)) } catch { /* House audio remains available. */ }
}
